import { render } from "./LeftComponent.vue?vue&type=template&id=f336f8b8&scoped=true"
import script from "./LeftComponent.vue?vue&type=script&lang=js"
export * from "./LeftComponent.vue?vue&type=script&lang=js"

import "./LeftComponent.vue?vue&type=style&index=0&id=f336f8b8&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f336f8b8"]])

export default __exports__